import { render, staticRenderFns } from "./commercialListItemFive.vue?vue&type=template&id=3a8b2c40"
import script from "./commercialListItemFive.vue?vue&type=script&lang=js"
export * from "./commercialListItemFive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports